import React from 'react'
import { ISelectedFilterListing } from '../types'
import { Flex, Button, Span } from '../../main'
import {
  FaTimes,
  isEmpty,
  startCase,
  toTileCase,
  snakeCase
} from '@fareye/utils'
import { IKeyValue } from '@fareye/types'
import { useState } from 'react'

const exceptions: any = {
  DisconnectionAlertSubscription: 'Disconnection Alert',
  IdleAlertSubscription: 'Idle Alert',
  OverspeedAlertSubscription: 'Overspeed Alert',
  TsDelayAlertSubscription: 'Ts Delay Alert',
  RolloverAlertSubscription: 'Roll Over Alert',
  POLDelayAlertSubscription: 'POL Delay Alert',
  VehicleBreakdownAlertSubscription: 'Vehicle Breakdown Alert',
  RouteDevAlertSubscription: 'Route Deviation Alert',
  PoiDurationAlertSubscription: 'POI Duration Alert',
  TemperatureExceedAlertSubscription: 'Temperature Exceed Alert',
  EtaAlertSubscription: 'Eta Alert',
  BlackoutAlertSubscription: 'Blackout Alert',
  UnloadingDelayAlertSubscription: 'Unloading Delay Alert'
}

function SelectedFilterListing({
  selectedFilters,
  setSelectedFilters
}: ISelectedFilterListing) {
  const [filtersSelected, setFiltersSelected] = useState<any>([])
  React.useEffect(() => {
    if (!isEmpty(selectedFilters.selectedFilters)) {
      let arr: any = []
      Object.keys(selectedFilters.selectedFilters).forEach((ele: any) => {
        selectedFilters.selectedFilters[ele].forEach((res: any) => {
          arr.push({ key: ele, label: res })
        })
      })
      setFiltersSelected(arr)
    }
  }, [selectedFilters.selectedFilters])
  function removeSelected(item: IKeyValue<string | number>) {
    let tempFiltered: any = filtersSelected?.filter((ele: any) => {
      return !(ele.key === item.key && ele.label === item.label)
    })
    let formatObj: any = {}
    tempFiltered.forEach((res: any) => {
      if (formatObj[res.key]) {
        formatObj[res.key].push(res.label)
      } else {
        formatObj[res.key] = [res.label]
      }
    })
    setFiltersSelected(tempFiltered)
    setSelectedFilters && setSelectedFilters({ selectedFilters: formatObj })

    // const tempSearch: any[] | undefined = selectedFilters?.filter(
    //   (filter: IKeyValue<string | number>) => {
    //     return !(filter.key === item.key && filter.value === item.value)
    //   }
    // )

    // setSelectedFilters ? setSelectedFilters(tempSearch) : null
  }
  const remove = () => {
    setSelectedFilters ? setSelectedFilters({ selectedFilters: {} }) : null
  }
  return (
    <Flex
      style={{ width: '100%' }}
      alignItemsFlexStart
      //   style={{ margin: `${selectedFilters.length > 0 ? '5px 0 0 0' : 0}` }}
    >
      {!isEmpty(filtersSelected) ? (
        <>
          <Flex style={{ flex: '0 0 auto' }}>
            <Span
              m={2}
              width={54}
              style={{ cursor: 'pointer' }}
              variant="primary"
              onClick={() => remove()}
            >
              Clear All
            </Span>
          </Flex>
          <Flex style={{ flex: '1 0 100px', overflow: 'auto' }}>
            {filtersSelected?.map((item: any, i: any) => (
              <Button
                m={1}
                key={i}
                variant="secondary xs"
                rightStyle={{ marginLeft: 5 }}
                rightChild={
                  <FaTimes color="#333" onClick={() => removeSelected(item)} />
                }
              >
                {item.key === 'alert_event_types'
                  ? exceptions[item.label]
                  : startCase(item.label)}
              </Button>
            ))}
          </Flex>
        </>
      ) : null}
    </Flex>
  )
}

export default SelectedFilterListing
